module.exports = __webpack_public_path__ + "img/IMPORT.e113b11e.svg";